import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import * as React from 'react';

import type { QuickLinkTileProps } from './QuickLinkTile.types';

import styles from './QuickLinkTile.module.css';

const QuickLinkTile = React.memo(
  ({
    label,
    icon: Icon,
    onClick,
  }: Readonly<QuickLinkTileProps>): React.ReactElement => {
    const isMobile = useMediaQuery(MediaQuery.Mobile);

    return (
      <CobaltClickableTile
        onClick={onClick}
        className={styles.quickLinkTile}
        data-testid={`quick-link-tile-${label.toLowerCase().replaceAll(/\s+/g, '-')}`}
      >
        <Icon
          size={isMobile ? 'medium' : 'large'}
          className={styles.quickLinkIcon}
        />
        <span
          className={
            isMobile ? `body-02 ${styles.quickLinkLabel}` : `heading-01 `
          }
        >
          {label}
        </span>
      </CobaltClickableTile>
    );
  }
);

QuickLinkTile.displayName = 'QuickLinkTile';

export { QuickLinkTile };
